import moment from "moment";

export default class LicenseUser {
  constructor(raw = {}) {
    this.id = raw.id;
    this.username = raw.username;
    this.name = raw.name;
    this.email = raw.email;
    this.surname = raw.surname;
    this.isOpen = raw.licenceState === 0;
    this.isPlanned = raw.licenceState === 1;
    this.isTaken = raw.licenceState === 2;
    this.certificateLink = raw.certificateLink;
    this.isActive = raw.isActive ?? false;
    this.courseRunId = raw.courseRunId;
    this.startDate = raw.startDate;
    this.endDate = raw.endDate;
    this.canRestart = raw.canRestart;
    this.canReset = raw.canReset;
    this.assignmentDate = raw.assignmentDate;
    this.departments = raw.departments;
    this.progress = raw.progress;
  }

  get isFinished() {
    return this.isTaken && this.endDate;
  }

  get isFailed() {
    return !this.isSuccess && this.endDate;
  }

  get isSuccess() {
    return this.certificateLink !== null && this.certificateLink !== undefined;
  }

  get isStartedButNotFinished() {
    return (!this.isFinished || this.certificateLink === null) && this.startDate
        !== undefined;
  }

  get fullName() {
    return this.name + " " + this.surname;
  }

  get startDateMoment() {
    return moment(this.startDate);
  }

  get endDateMoment() {
    return moment(this.endDate);
  }

}

